<template>
  <!-- 课程类别 -->
  <div>
    <div style="padding: 10px 0 10px 0; text-align: left">
      <el-button type="primary" @click="add()" size="small" icon="el-icon-plus" class="btns">添加类别</el-button>
      <el-button type="primary" @click="addFile" size="small" icon="el-icon-plus" class="btns">保存权限配置</el-button>
      <!-- <div style="color: #ccc; font-size: 12px; margin-top: 5px;">注：</div> -->
    </div>
    <!-- <el-table
    size="small"
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column type="index"></el-table-column> -->
    <!-- <el-table-column prop="id" label="id" sortable width="180"></el-table-column> -->
    <!-- <el-table-column prop="categoryName" label="名称" sortable></el-table-column> -->
    <!-- <el-table-column prop="remark" label="备注"></el-table-column> -->
    <!-- <el-table-column label="级别">
        <template slot-scope="scope">{{scope.row.parentId == 0 ? '一级类别' : '二级类别'}}</template>
      </el-table-column>
      <el-table-column prop="categoryNo" label="编号" width="100"></el-table-column>
      <el-table-column prop="id" label="#" sortable width="100"></el-table-column>

      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="deleteById(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table> -->

  <div style="display: flex; justify-content: space-between;">
    <el-tree :accordion="true" :data="tableData" show-checkbox default-expand-all current-node-key node-key="id" ref="trees"
      :expand-on-click-node="false" :props="defaultProps"  @check="handleClickTree" style="width: 30%;">
                                         <!-- {node, data} -->
      <span class="custom-tree-node" slot-scope="{ node }">
        <span>{{ node.label }}</span>
        <span>
          <el-button type="text" size="mini" @click="() => append(node)">
            添加
          </el-button>
          <!-- <el-button
            type="text"
            size="mini"
            @click="() => remove(node, tableData)"
          >
            删除
          </el-button> -->
          <el-button type="text" size="mini" @click="() => editBtn(node, tableData)">
            编辑
          </el-button>
        </span>
      </span>
    </el-tree>

     <el-tree
        ref="tree"
        style="width: 50%;"
        :data="fileDataList"
        show-checkbox
        node-key="folderId"
        default-expand-all
        current-node-key
        :expand-on-click-node="false"
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
        @check="handleCheck"
        :props="fileDefaultProps">
     </el-tree>

   
  </div>

    <el-dialog :title="editControl ? '编辑类别' : '添加类别'" :visible.sync="visibleForm" width="500px">
      <el-form :model="editFormData" label-position="left" label-width="80px">
        <el-form-item label="No" prop="categoryNo">
          <el-input clearable v-model="editFormData.categoryNo" autocomplete="off" placeholder="请输入一个ID"
            :disabled="flog"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="categoryName">
          <el-input clearable v-model="editFormData.categoryName" autocomplete="off" @input="changeMessage"></el-input>
        </el-form-item>
        <el-form-item label="父级ID" prop="parentId">
          <el-input clearable v-model="editFormData.parentId" autocomplete="off" placeholder="0为一级类别"
            :disabled="editControl"></el-input>
        </el-form-item>
        <el-form-item style="text-align: left">
          <el-button type="primary" @click="save()" size="small"><span v-if="!editControl">提 交</span>
            <span v-else>编 辑</span></el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseUrl from "../../../config/api";
export default {
  name: "OnlineCategory",
  data () {
    return {
      flog: false,
      tableData: [],
      defaultProps: {
        children: "children",
        label: "categoryName",
      },
      fileDefaultProps:{
        children: "children",
        label: "folderName",
      },
      visibleForm: false,
      editFormData: {
        categoryNo: null,
        categoryName: null,
        parentId: 0,
      },
      editControl: false,
      fileDataList:[],
      categoryId:'',
      folderId:'',
    };
  },
  mounted () { },
  created () {
    this.init();
  },
  methods: {
    add () {
      this.visibleForm = true;
      this.flog = false;
      // this.isShow=!this.isShow
      this.editFormData = {};
    },
    init () {
      // this.tableData1 = [];
      this.$axios.get(`${apiBaseUrl}/category/list`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((r) => {
        this.tableData = r.data.data;
        
        
        // let c = r.data.data;

        // c.map(v => {
        //   this.$axios.get(`${apiBaseUrl}/category/two/` + v.id).then(rr => {

        //     this.tableData1.push(
        //       //   {
        //       //   id: v.id,
        //       //   categoryName: v.categoryName,
        //       //   children: rr.data.data,
        //       //   categoryNo: v.categoryNo,
        //       //   parentId: v.parentId
        //       // }
        //       {
        //         label: v.categoryName,
        //         categoryNo: v.categoryNo,
        //         id: v.parentId,
        //         children: rr.data.data
        //       }
        //     );
        //   });
        // });
     

        this.$axios.get(`${apiBaseUrl}/folder/getAllFolder`,{
          headers:{
            'authorization':sessionStorage.getItem('tokenInfo')
          }
        }).then((res)=>{
          if(res.data.code === 200){
            
            this.fileDataList = res.data.data
          }else{
            this.$message({
            type: "error",
            message: res.data.message,
          });
          }
        })
      });
    },

    addFile(node){
      

      let data ={
        folderId:this.folderId,
        categoryId:this.categoryId
      }
      this.$axios.post(`${apiBaseUrl}/courseFolder/addCourseFolder`, data,{
        headers:{
            'authorization':sessionStorage.getItem('tokenInfo')
          }
      }).then((res)=>{
        
        if(res.data.code === 200){
          this.$message({ message: res.data.message, type: "success" });
        }else{
          this.$message({message:'只能选择具体科目，选择文件夹是不生效的哦~', type: "error" });

        }

      })

    },
    handleCheck(data, checked) {
      this.folderId = []
      console.log('this.folderId : ', this.folderId );
      const checkedNodes = this.$refs.tree.getCheckedNodes();
      const checkedIds = checkedNodes.map(node => node.folderId);
      


      const halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
      const halfCheckedIds = halfCheckedNodes.map(node => node.folderId);
      const allRelatedIds = [...new Set([...checkedIds, ...halfCheckedIds])];
      
      this.folderId = allRelatedIds.join(',');
      
    },

    handleClickTree(data,checked){
        if (checked.checkedKeys.includes(data.id)) {
          this.$refs.trees.setCheckedKeys([]);
          this.$refs.trees.setCheckedKeys([data.id]);
          this.checkedKeys = [data.id];
        } else {
          this.$refs.trees.setCheckedKeys([]);
          this.checkedKeys = [];
        }

      this.categoryId = data.id
      console.log('data.id: ', data.id);
      this.$axios.get(`${apiBaseUrl}/courseFolder/getFolder/${data.id}`,{
              headers:{
                'authorization':sessionStorage.getItem('tokenInfo')
              }
            }).then((res)=>{
              if(res.data.code === 200){
                this.$refs.tree.setCheckedKeys([]);
                if(res.data.data !== null){
                  const checkedKeys = res.data.data.folderId.split(',');
                  // this.$refs.tree.setCheckedKeys(checkedKeys,false);
                  checkedKeys.forEach(key => {
                    this.$refs.tree.setChecked(key, true, false);
                  });
                }else{
                  this.$refs.tree.setCheckedKeys([]);

                }
               
              }else{
                this.$message({
                type: "error",
                message: res.data.message,
              });
              }
            })
    
    },
   

    
    allowDrop(draggingNode, dropNode, type) {
        return dropNode.data.deptName !== '蒙正课堂';
    },

    allowDrag(draggingNode) {
        return draggingNode.data.deptName !== '蒙正课堂';
    },

    save () {
      if (this.editControl) {
        this.$axios({
          method: "post",
          url: `${apiBaseUrl}/category/update`,
          
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          },
        
          data: {
            categoryName: this.editFormData.categoryName,
            id: this.editFormData.id,
            parentId: this.editFormData.parentId,
          }
        }).then((r) => {
          if (r.data.code == 200) {
            this.$message({ message: "编辑成功", type: "success" });
            this.init();
          }
        });
      } else {
        this.$axios({
          method: "post",
          url: `${apiBaseUrl}/category/add`,
          params: {
            categoryNo: this.editFormData.categoryNo,
            categoryName: this.editFormData.categoryName,
            parentId: this.editFormData.parentId,
          },
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          
        }
        }).then((r) => {
          if (r.data.code == 200) {
            this.$message({ message: "添加成功", type: "success" });
            this.init();
          }
        });
      }
      this.editFormData = {};
      this.visibleForm = false;
    },
    // deleteById(v) {
    //   
    //   this.$axios.delete(`${apiBaseUrl}/category/delete/` + v.id).then(r => {
    //     if (r.data.code == 0) {
    //       this.$message({ message: "删除成功", type: "success" });
    //       this.init();
    //     }
    //   });
    // }
    remove (node) {
      // this.$axios
      //   .delete(`${apiBaseUrl}/category/delete/` + node.data.id)
      //   .then(r => {
      //     if (r.data.code == 200) {
      //       this.$message({ message: "删除成功", type: "success" });
      //       this.init();
      //     }
      //   });
      this.$confirm("此操作将永久删除该节点, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .delete(`${apiBaseUrl}/category/delete/` + node.data.id,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
            .then((r) => {
              if (r.data.code == 200) {
                this.$message({ message: "删除成功", type: "success" });
                this.init();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    append (node) {
      this.flog = true;
      this.editControl = false;
      this.visibleForm = true;
      this.editFormData.categoryNo = node.data.categoryName;
      this.editFormData.parentId = node.data.id;
      this.$set(this.tableData);
    },
    changeMessage () {
      this.$forceUpdate()
    },
    editBtn (node) {
      
      this.flog = true;
      this.editControl = true;
      this.visibleForm = true;
      this.editFormData.categoryNo = node.data.categoryName;
      this.editFormData.categoryName = JSON.parse(JSON.stringify(node.data.categoryName))
      this.editFormData.id = node.data.id;
      this.editFormData.parentId = node.level == 1 ? 0 : node.data.parentId;
    },
  },
};
</script>

<style lang="less" scoped>
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/components/OnlineCategory.vue